export const categories = [
  {
    slug: 'short-video',
    name: '短视频制作',
    description: '从创意策划到后期制作，一站式短视频内容生产服务，覆盖抖音、快手、微信视频号等主流平台',
    icon: 'ri-film-line',
    color: 'primary',
    articleCount: 28,
  },
  {
    slug: 'brand-marketing',
    name: '品牌营销',
    description: '深度洞察品牌基因，构建差异化品牌策略，打造具有影响力的品牌形象与传播体系',
    icon: 'ri-megaphone-line',
    color: 'accent',
    articleCount: 35,
  },
  {
    slug: 'ad-planning',
    name: '广告策划',
    description: '精准定位目标受众，创意驱动广告内容，实现品效合一的广告投放与传播效果',
    icon: 'ri-lightbulb-flash-line',
    color: 'secondary',
    articleCount: 22,
  },
  {
    slug: 'social-media',
    name: '社交媒体运营',
    description: '多平台社交媒体矩阵运营，内容规划、粉丝互动、数据追踪，持续提升品牌社交影响力',
    icon: 'ri-share-line',
    color: 'primary',
    articleCount: 31,
  },
  {
    slug: 'content-creative',
    name: '内容创意',
    description: '以用户洞察为原点，创造有温度、有态度、有传播力的品牌内容，让创意自带流量',
    icon: 'ri-brush-line',
    color: 'accent',
    articleCount: 26,
  },
  {
    slug: 'full-service',
    name: '全案服务',
    description: '整合策略、创意、媒介、技术资源，提供端到端的品牌全案营销解决方案',
    icon: 'ri-stack-line',
    color: 'secondary',
    articleCount: 18,
  },
];